import React, { useEffect, useState } from "react";
import { DropdownButton, Nav, Navbar, Dropdown } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { confirmAlert } from "react-confirm-alert";
import { logout } from "../../../Action/Auth.action";
import { Link, useNavigate } from "react-router-dom";
import AxiosApi from "../../../Helper/axios.api";
import logo from '../../../assets/images/logo-blue.png'
export default function NavBar(props) {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const auth = useSelector((state) => state.auth);

  const [fullName, setFullName] = useState(auth.name);
  const [firstName, setFirstName] = useState(auth.userDeatils.name);
  const [lastName, setLastName] = useState(auth.userDeatils.name);
  // Persistent maintenance banner state
  const [maintanenceNoticeDate, setMaintanenceNoticeDate] = useState("");
  const [maintanenceNoticeDetail, setMaintanenceNoticeDetail] = useState("");
  const [showMaintanenceDetail, setShowMaintanenceDetail] = useState(false);
  const logOut = () => {
    confirmAlert({
      title: "Logout",
      message: "Are you sure you want to log out?",
      buttons: [
        {
          label: "Yes",
          onClick: () => {
            dispatch(logout());
            navigate("/login", { replace: true });
          },
        },
        {
          label: "No",
        },
      ],
    });
  };
  useEffect(()=>{
    let name = auth.name.split(" ");
    setFullName(auth.name)
    setFirstName(name[0])
    if(name.length > 2){
      setLastName(name[name.length-1] ? name[name.length-1] : "")
    }else{
      setLastName(name[1] ? name[1] : "")
    }

    return function() {
      /**
       * Add cleanup code here
       */
    };
  },[auth.name]);

  useEffect(() => {
    const normalize = (p) => ({
      start: p.start || p.start_time,
      end: p.end || p.end_time || p.until,
      note: p.note || p.message || p.detail,
      status: p.status,
    });

    const formatDT = (dt) => {
      try {
        return dt ? new Date(dt).toLocaleString() : '';
      } catch {
        return dt || '';
      }
    };

    const checkMaintenance = async () => {
      try {
        const res = await AxiosApi.withToken(
          auth.accessToken,
          'maintenance/status',
          'get'
        );

        if (!res || res.status === false) return;

        let periods = [];
        const d = res.data;
        if (Array.isArray(d)) periods = d;
        if (Array.isArray(d?.periods)) periods = d.periods;
        if (Array.isArray(d?.ongoing)) periods = periods.concat(d.ongoing);
        if (Array.isArray(d?.upcoming)) periods = periods.concat(d.upcoming);
        if (!periods.length && d?.start && d?.end) periods = [d];

        const now = Date.now();
        const normalized = periods
          .map(normalize)
          .filter((p) => p.start && p.end);

        if (!normalized.length) return;

        const ongoing = normalized.filter((p) => {
          const s = Date.parse(p.start);
          const e = Date.parse(p.end);
          return !isNaN(s) && !isNaN(e) && s <= now && e >= now;
        });
        const upcoming = normalized.filter((p) => {
          const s = Date.parse(p.start);
          return !isNaN(s) && s > now;
        });

        const pick = ongoing[0] || upcoming.sort((a, b) => Date.parse(a.start) - Date.parse(b.start))[0];
        if (!pick) return;

        const isOngoing = ongoing.includes(pick);
        const title = isOngoing ? 'Maintenance In Progress' : 'Scheduled Maintenance';
        const message = isOngoing
          ? `DeepTherapy is under maintenance now until ${formatDT(pick.end)}.`
          : `DeepTherapy will be unavailable from ${formatDT(pick.start)} to ${formatDT(pick.end)}.`;
        const note = pick.note ? `\n\nNote: ${pick.note}` : '';

        // Persistent banner content
        setMaintanenceNoticeDate(
          isOngoing
            ? `until ${formatDT(pick.end)}`
            : `${formatDT(pick.start)} → ${formatDT(pick.end)}`
        );
        setMaintanenceNoticeDetail(
          `${message}${pick.note ? `\n${pick.note}` : ''}`.trim()
        );

        confirmAlert({
          title,
          message: message + note,
          buttons: [
            {
              label: 'OK',
            },
          ],
          closeOnClickOutside: true,
          closeOnEscape: true,
        });
      } catch (e) {
        // Silently ignore maintenance status errors in navbar
        // console.error('Failed to fetch maintenance status', e);
      }
    };

    checkMaintenance();
    // run only once on mount
  }, []);
  return (
    <>
      <header
        id="header"
        className="page-header d-flex align-items-center justify-content-between p-1 flex-wrap"
      >
        <div className="logo-col d-flex align-items-center p-1 ">
          <Link to="/dashboard" className="logo-link d-flex align-items-center">
            <img
              src={logo}
              alt="DeepTherapy"
              width="36"
              height="36"
            />
            <span className="logo-text">DeepTherapy</span>
          </Link>
        </div>
        {maintanenceNoticeDate && (
          <div
            style={{
              position: 'relative',
              margin: '0 1.5rem',
              borderRadius: '20px',
              padding: '.5rem 1.5rem',
              fontWeight: 'bold',
              boxShadow: '0 2px 8px rgba(102, 126, 234, 0.3)',
              color: '#8B4513',
              background: 'linear-gradient(135deg, #ffecd2 0%, #fcb69f 100%)',
              cursor: 'pointer',
              maxWidth: '520px',
              overflow: 'visible',
              whiteSpace: 'nowrap',
              textOverflow: 'ellipsis'
            }}
            onClick={() => setShowMaintanenceDetail((x) => !x)}
            title="Click to toggle details"
          >
            <i className="fas fa-exclamation-triangle"></i>
            {' '}Maintenance: {maintanenceNoticeDate}
            <div
              style={{
                visibility: showMaintanenceDetail ? 'visible' : 'hidden',
                position: 'absolute',
                zIndex: '999',
                top: '100%',
                left: '0',
                marginTop: '.5rem',
                background: '#f7f8f9',
                color: 'black',
                borderRadius: '12px',
                padding: '.75rem 1rem',
                fontWeight: 'initial',
                boxShadow: '0 2px 8px rgba(102, 126, 234, 0.3)',
                maxWidth: '640px',
                whiteSpace: 'pre-wrap'
              }}
            >
              {maintanenceNoticeDetail}
            </div>
          </div>
        )}
        <div className="mobile-toggel d-block d-md-none px-4" role="button" onClick={() => props.setShowmenu(!props.showmenu)}>
        <i className="fa fa-bars" aria-hidden="true"></i>
        </div>
        <div className="header-right d-flex align-items-center">
          {/* <div className="customer-post">MF</div> */}
          <Navbar brand="React-Bootstrap" className="drp-navbar-top">
            <Nav right="true"  className="drp-nav-top">
              <DropdownButton
                variant={"bg-transparent"}
                className="drp-navbar-name"
                title={
                  <>
                  <div className="customer-post" style={{width:'35px',height:'35px'}}>
                        {firstName.charAt(0)}{lastName.charAt(0)}
                    </div>
                    <span>{fullName}</span>
                  </>
                }
              >
                <Dropdown.Item as={Link} to="/profile">
                  {/* <Link to="/profile" className="video-item"> */}
                    <i className="fa fa-gear fa-fw"></i> User Profile
                  {/* </Link> */}
                </Dropdown.Item>

                <Dropdown.Item onClick={() => logOut()}>
                  <i className="fa fa-sign-out fa-fw"></i> Logout
                </Dropdown.Item>
              </DropdownButton>
            </Nav>
          </Navbar>

        </div>
      </header>
    </>
  );
}
